module.exports = __webpack_public_path__ + "fonts/fa-brands-400.1f6bad9.woff2";